import axios from 'axios';
import Cookies from 'js-cookie';

export const requestASignupLink = ({params}) => {
  return axios({
    method: 'post',
    url: `/ticket/request-link/`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};


export const verifyEmail = ({token}) => {
  return axios({
    method: 'get',
    url: `/signup/email-verify/?token=${token}`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const verifyPhoneNumber = ({params}) => {
  return axios({
    method: 'post',
    url: '/signup/phone-verify/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const verifyPhoneNumberOtp = ({params}) => {
  return axios({
    method: 'post',
    url: '/signup/code-verify/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const createPassword = ({params}) => {
  return axios({
    method: 'post',
    url: '/signup/set-password/',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
